import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "./AuthShell";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(form.email, form.password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      navigate(res.user.role === "admin" ? "/admin" : "/dashboard");
    } else {
      setError(res.error);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Log in to your compliance command center."
      footer={<>New here? <Link to="/signup" data-testid="link-signup" className="text-dox-orange font-semibold hover:underline">Start your free trial</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Input label="Email" type="email" testid="login-email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} />
        <Input label="Password" type="password" testid="login-password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} />
        {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
        <button
          data-testid="login-submit"
          disabled={loading}
          className="w-full rounded-full bg-dox-orange py-3.5 font-bold text-white hover:bg-dox-orangeHover disabled:opacity-60 transition-all min-h-[52px]"
        >
          {loading ? "Logging in…" : "Log in"}
        </button>
        <div className="text-right">
          <Link to="/forgot-password" data-testid="link-forgot-password" className="text-xs font-semibold text-white/50 hover:text-dox-orange">Forgot password?</Link>
        </div>
      </form>
    </AuthShell>
  );
}

function Input({ label, type, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-1.5 block">{label}</span>
      <input
        data-testid={testid}
        required
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-dox-orange focus:ring-2 focus:ring-dox-orange/20 transition"
      />
    </label>
  );
}
